
import { Modal as AntdModal, Button } from 'antd';
import { useState } from "react";
import FormService from '../../../../redux/services/forms';

import { getHeight } from "../../misc/layouts";

export default function ViewPages({ comps, setComps, setView, page, setPage, pages, setPages }) {

    const [dragIndex, setDragIndex] = useState(null);
    const [dragOverIndex, setDragOverIndex] = useState(null);

    // Reorder a page and remap every element's `page` index to follow.
    const movePage = (from, to) => {
        if (from === null || to === null || from === to) return;
        let new_pages = [...pages];
        const [moved] = new_pages.splice(from, 1);
        new_pages.splice(to, 0, moved);

        // Object identity is preserved by splice, so we can map old -> new index.
        const oldToNew = {};
        for (let oldIdx = 0; oldIdx < pages.length; oldIdx++) {
            oldToNew[oldIdx] = new_pages.indexOf(pages[oldIdx]);
        }

        let new_comps = [...comps];
        for (let j = 0; j < new_comps.length; j++) {
            const np = oldToNew[new_comps[j].page];
            if (np !== undefined && np !== new_comps[j].page) {
                new_comps[j] = { ...new_comps[j], page: np };
            }
        }
        setComps(new_comps);
        setPages(new_pages);
        if (oldToNew[page] !== undefined) setPage(oldToNew[page]);
    };

    const addPage = () => {
        let new_pages = [...pages];
        new_pages.splice(page, 0, {
            page_id: FormService.getGUID(),
            height: getHeight('A4', 0.7),
            visibleTo: 'all'
        });
        setPages(new_pages);

        let new_comps = [...comps];
        for (let k = 0; k < new_comps.length; ++k) {
            if (new_comps[k].page > page) {
                new_comps[k].page += 1;
            }
        }
        setComps(new_comps);
        setPage(page + 1);
    };

    const deletePage = (k) => {
        if (pages.length <= 1) return;
        if (!window.confirm('Are you sure you want to delete this page?')) return;
        let new_comps = [...comps];
        let newer_comps = [];
        for (let j = 0; j < new_comps.length; ++j) {
            if (new_comps[j].page < k) {
                newer_comps.push(new_comps[j]);
            } else if (new_comps[j].page > k) {
                new_comps[j].page -= 1;
                newer_comps.push(new_comps[j]);
            }
        }
        setComps(newer_comps);
        let new_pages = [...pages];
        new_pages.splice(k, 1);
        if (page > k) {
            setPage(page - 1);
        } else if (k === pages.length - 1 && page === k) {
            setPage(k - 1);
        }
        setPages(new_pages);
    };

    let page_list = [];
    for (let k = 0; k < pages.length; k++) {
        const current = page === k;
        const isDragOver = dragOverIndex === k && dragIndex !== null && dragIndex !== k;
        const accent = current ? 'var(--ed-accent)' : 'var(--ed-text-soft)';
        page_list.push(
            <div key={k}
                onDragOver={(e) => {
                    if (dragIndex === null) return;
                    e.preventDefault();
                    if (dragOverIndex !== k) setDragOverIndex(k);
                }}
                onDrop={(e) => {
                    e.preventDefault();
                    movePage(dragIndex, k);
                    setDragIndex(null);
                    setDragOverIndex(null);
                }}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                    padding: '10px 12px',
                    borderRadius: 8,
                    marginBottom: 8,
                    border: '1px solid ' + (current ? 'var(--ed-accent)' : 'var(--ed-border)'),
                    borderTop: isDragOver
                        ? '2px solid var(--ed-accent)'
                        : ('1px solid ' + (current ? 'var(--ed-accent)' : 'var(--ed-border)')),
                    background: current ? 'var(--ed-accent-soft)' : 'var(--ed-surface-2)',
                    opacity: dragIndex === k ? 0.4 : 1,
                    transition: 'opacity .1s, border-color .1s'
                }}>
                <span
                    draggable
                    onDragStart={() => setDragIndex(k)}
                    onDragEnd={() => {
                        setDragIndex(null);
                        setDragOverIndex(null);
                    }}
                    title="Drag to reorder"
                    className="var-drag-handle"
                    style={{
                        flex: '0 0 auto',
                        display: 'inline-flex',
                        alignItems: 'center',
                        padding: '0.35vmax 0.6vmax',
                        border: '1px dashed var(--ed-border-strong)',
                        borderRadius: 6,
                        color: 'var(--ed-text-soft)',
                        fontSize: '0.95vmax',
                        cursor: 'grab',
                        userSelect: 'none'
                    }}>
                    <i className="fa fa-solid fa-arrows-v"></i>
                </span>

                <i className="fa fa-solid fa-file-o" style={{
                    flex: '0 0 auto',
                    color: accent,
                    fontSize: '1.2vmax'
                }}></i>

                <div style={{ flex: '1 1 auto', minWidth: 0 }}>
                    <p className="panel-label" style={{
                        margin: 0,
                        fontWeight: 500,
                        fontSize: '1.05vmax',
                        color: current ? 'var(--ed-accent)' : 'var(--ed-text)'
                    }}>Page {k + 1}{current ? ' (current)' : ''}</p>
                    <p style={{
                        margin: 0,
                        color: 'var(--ed-text-soft)',
                        fontSize: 11,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }}>{pages[k].page_id}</p>
                </div>

                <i className="fa fa-solid fa-eye page-row-action" title="Go to page" style={{
                    flex: '0 0 auto',
                    color: accent,
                    fontSize: '1.2vmax',
                    cursor: 'pointer'
                }} onClick={() => setPage(k)}></i>

                <i className="fa fa-solid fa-trash page-row-action page-row-trash" title="Delete page" style={{
                    flex: '0 0 auto',
                    color: 'var(--ed-text-soft)',
                    fontSize: '1.1vmax',
                    cursor: 'pointer'
                }} onClick={() => deletePage(k)}></i>
            </div>
        );
    }

    return (
        <AntdModal className="cf-modal" title="View Pages" visible={true} onOk={() => {
            setView('');
        }} onCancel={() => {
            setView('');
        }}
            footer={[
                <Button key="add" type="primary" onClick={(e) => {
                    e.preventDefault();
                    addPage();
                }}>
                    Add Page
                </Button>
            ]}
        >
            <p className='panel-label' style={{ marginBottom: 10 }}>
                Drag the handle to reorder pages.
            </p>
            <div style={{
                maxHeight: '55vh',
                overflowX: 'hidden',
                overflowY: 'auto',
                padding: '2px'
            }}>
                {page_list}
            </div>
        </AntdModal>
    );

}
